exports.onRouteUpdate = ({ location }) => {
  const sendPageViewWhenReady = window.setInterval(() => {
    if (window.goatcounter && window.goatcounter.count) {
      window.clearInterval(sendPageViewWhenReady)
      window.setTimeout(() => {
        window.goatcounter.count({
          path: location.pathname + location.search + location.hash,
        })
      }, 32)
    }
  }, 100)
}
